import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell, Box, Typography } from '@mui/material'


const TextHeader = ({ label, ...props }) =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <Typography sx={{ color: 'text.label', textAlign: 'center', fontSize: 13, fontWeight: 600 }}>
      {label}
    </Typography>
  </Box>

const Header = props => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companycontract.name')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companycontract.client_id')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companyservice.name')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companyservice.code')} />
  </TableCell>
</>

export default React.memo(Header)
